import {
  SmartcardNotFoundError,
  UnexpectedError,
} from "../../../domain/errors";
import { SmartcardAlreadyRegisteredError } from "../../../domain/errors/smartcard-already-exists-error";
import { AmendSmartcard } from "../../../domain/usecases/amend-smartcard";
import { HttpClient, HttpStatusCode } from "../../protocols/http";

export class RemoteAmendSmartcard implements AmendSmartcard {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<void>
  ) {}

  async amend(params: AmendSmartcard.Params): Promise<void> {
    console.log("AmendSmartcard.Params", params);
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: "post",
      body: params,
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body!;
      case HttpStatusCode.notFound:
        throw new SmartcardNotFoundError();
      case HttpStatusCode.conflict:
        throw new SmartcardAlreadyRegisteredError();
      default:
        throw new UnexpectedError();
    }
  }
}

// export namespace RemoteAmendAccount {
//   export type Model = CreateUser.Model;
// }
